import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'home',
		component: () => import('../views/index/index.vue')
	},

	{
		path: '/mianfu_release',
		name: 'mianfu_release',
		component: () => import('../views/mianfu_release/mianfu_release.vue')
	},
	{
		path: '/fuzhuang_release',
		name: 'fuzhuang_release',
		component: () => import('../views/fuzhuang_release/fuzhuang_release.vue')
	}, {
		path: '/gongyi_release',
		name: 'gongyi_release',
		component: () => import('../views/gongyi_release/gongyi_release.vue')
	}, {
		path: '/motorcade_release',
		name: 'motorcade_release',
		component: () => import('../views/motorcade_release/motorcade_release.vue')
	}, {
		path: '/daizhao_release',
		name: 'daizhao_release',
		component: () => import('../views/daizhao_release/daizhao_release.vue')
	},

	{
		path: '/market',
		name: 'market',
		component: () => import('../views/market/market.vue')
	},
	{
		path: '/market_details',
		name: 'market_details',
		component: () => import('../views/market_details/market_details.vue')
	},

	{
		path: '/registration_application',
		name: 'registration_application',
		component: () => import('../views/registration_application/registration_application.vue')
	},
	{
		
		path: '/line_application',
		name: 'line_application',
		component: () => import('../views/line_application/line_application.vue')
	},
	{
		path: '/company',
		name: 'company',
		component: () => import('../views/company/company.vue'),
		redirect: '/company/basic_information',
		children: [{
				path: 'basic_information',
				name: 'basic_information',
				component: () => import('../views/company/basic_information/basic_information.vue'),
			}, {
				path: 'store_information',
				name: 'store_information',
				component: () => import('../views/company/store_information/store_information.vue'),
			}, {
				path: 'division_management',
				name: 'division_management',
				component: () => import('../views/company/division_management/division_management.vue'),
			}, {
				path: 'product_image',
				name: 'product_image',
				component: () => import('../views/company/product_image/product_image.vue'),
			},

		]
	},
	{
		path: '/member',
		name: 'member',
		component: () => import('../views/member/member.vue')
	},
	{
		path: '/order_goods',
		name: 'order_goods',
		component: () => import('../views/order_goods/order_goods.vue')
	},
	{
		path: '/order_details',
		name: 'order_details',
		component: () => import('../views/order_details/order_details.vue')
	},
	{
		path: '/factory',
		name: 'factory',
		component: () => import('../views/factory/factory.vue')
	}, {
		path: '/factory_details',
		name: 'factory_details',
		component: () => import('../views/factory_details/factory_details.vue')
	},

	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/login.vue')
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: () => import('../views/login/agreement.vue')
	},
	{
		path: '/forgot_password',
		name: 'forgot_password',
		component: () => import('../views/forgot_password/forgot_password.vue')
	},
	{
		path: '/agreement-new',
		name: 'agreement_new',
		component: () => import('../views/agreement/agreement.vue')
	},
	{
		path: '/user',
		name: 'user',
		component: () => import('../views/user/user.vue'),
		redirect: '/user/query_history',
		children: [{
				path: 'query_history',
				name: 'query_history',
				component: () => import('../views/user/query_history/query_history.vue'),
			},
			{
				path: 'mySend',
				name: 'mySend',
				component: () => import('../views/user/mySend/mySend.vue'),
			},
			{
				path: 'myBaojia',
				name: 'myBaojia',
				component: () => import('../views/user/myBaojia/myBaojia.vue'),
			},
			{
				path: 'daili',
				name: 'daili',
				component: () => import('../views/user/daili/daili.vue'),
			},
			{
				path: 'collect',
				name: 'collect',
				component: () => import('../views/user/collect/collect.vue'),
			},
			{
				path: 'footprint',
				name: 'footprint',
				component: () => import('../views/user/footprint/footprint.vue'),
			},
			{
				path: 'invoice',
				name: 'invoice',
				component: () => import('../views/user/invoice/invoice.vue'),
			},
			{
				path: 'platform',
				name: 'platform',
				component: () => import('../views/user/platform/platform.vue'),
			},
			{
				path: 'idea',
				name: 'idea',
				component: () => import('../views/user/idea/idea.vue'),
			},
			{
				path: 'set',
				name: 'set',
				component: () => import('../views/user/set/set.vue'),
			}
		]
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router